import { forwardRef, useMemo } from 'react';
import OutlinedInput, { type OutlinedInputProps } from '@material-ui/core/OutlinedInput';

import { useCursorPositionFix } from 'src/lib/hooks/useCursorPositionFix';

interface Props extends OutlinedInputProps {
  inputProps?: Record<string, unknown>;
  disallowLogRocket?: boolean;
  dataTestId?: string;
}

export const CustomInput = forwardRef<HTMLInputElement, Props>(
  ({ inputProps, disallowLogRocket, dataTestId, value, onChange, ...restProps }, ref) => {
    const localInputProps = useMemo(
      () => ({
        ...inputProps,
        'data-testid': dataTestId,
        'data-private': disallowLogRocket ? '' : null,
        dir: 'auto',
      }),
      [inputProps, disallowLogRocket, dataTestId]
    );

    const { value: fixedValue, onChange: fixedOnChange } = useCursorPositionFix(value, onChange);

    // A Select hosts its value in this input but owns what is displayed. The cursor fix is for
    // typing — nobody types into a select — and its local copy is only ever right while the parent
    // accepts every choice: one that opens a prompt instead, and stores something else or nothing,
    // would leave the closed select showing the option the user picked to get there.
    const hostsSelect = Boolean(restProps.inputComponent);

    return (
      <OutlinedInput
        ref={ref}
        inputProps={localInputProps}
        value={hostsSelect ? value : fixedValue}
        onChange={hostsSelect ? onChange : fixedOnChange}
        {...restProps}
      />
    );
  }
);
